export enum CommentPingType {
  User = "User",
  Company = "Company",
  Anonymous = "Anonymous"
}
